// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Announcements: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 42 39" enableBackground="new 0 0 42 39" xmlSpace="preserve">
<path fillRule="evenodd" clipRule="evenodd" d="M38.06,0H3.94C1.77,0,0,1.92,0,4.26v22.71c0,2.34,1.77,4.26,3.94,4.26h13.33
	l1.92,6.42c0.1,0.16,0.22,0.3,0.38,0.41c0.6,0.43,1.42,0.26,1.82-0.39l5.04-6.44h11.64c2.17,0,3.94-1.92,3.94-4.26V4.26
	C42,1.92,40.23,0,38.06,0z M35.44,24.12H6.56c-0.72,0-1.31-0.64-1.31-1.42c0-0.78,0.59-1.42,1.31-1.42h28.87
	c0.72,0,1.31,0.64,1.31,1.42C36.75,23.48,36.16,24.12,35.44,24.12z M35.44,17.03H6.56c-0.72,0-1.31-0.64-1.31-1.42
	c0-0.78,0.59-1.42,1.31-1.42h28.87c0.72,0,1.31,0.64,1.31,1.42C36.75,16.39,36.16,17.03,35.44,17.03z M35.44,9.93H6.56
	c-0.72,0-1.31-0.64-1.31-1.42c0-0.78,0.59-1.42,1.31-1.42h28.87c0.72,0,1.31,0.64,1.31,1.42C36.75,9.29,36.16,9.93,35.44,9.93z"/>
</svg>;
};

export default React.memo(Announcements);
